import React from 'react'
import NumberFormat, { InputAttributes } from 'react-number-format'
import { TextField } from '@mui/material'

import { INumberFormatCustom } from '../commonInterfaces'

const NumberFormatCustom = React.forwardRef<NumberFormat<InputAttributes>, INumberFormatCustom>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        placeholder="4444 4444 4444 4444"
        format="#### #### #### ####"
        type="text"
        mask=" "
        allowNegative={false}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props?.name,
              value: values.value,
            },
          })
        }}
      />
    )
  }
)

export default function CreditCardNumber(): JSX.Element {
  return (
    <TextField
      className="credit-number"
      label="Card Number"
      name="credit-card-number"
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
      fullWidth
    />
  )
}
